import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/executive-leaving.svg";
var ExecutiveLeavingOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ExecutiveLeavingOutline_default as default
};
